<template>
    <div class="content-fidelization">
        <div class="content-fidelization-itens container">
            <div class="content-fidelization-itens-title">
                <h1 class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">A regra de fidelização  que melhor combina com o negócio</h1>
            </div>
            <div class="content-fidelization-itens-cards row">
                <div class="col-md-6">
                    <div class="content-fidelization-itens-cards-item">
                        <div class="content-fidelization-itens-cards-item-img">
                            <img src="@/assets/img/merchant/rule1.png" alt="">
                        </div>
                        <div class="content-fidelization-itens-cards-item-text">
                            <h2 class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">Desconto Direto</h2>
                            <p class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">
                                O cliente recebe a vantagem de forma imediata
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="content-fidelization-itens-cards-item">
                        <div class="content-fidelization-itens-cards-item-img">
                            <img src="@/assets/img/merchant/rule2.png" alt="">
                        </div>
                        <div class="content-fidelization-itens-cards-item-text">
                            <h2 class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">Desconto Diferido</h2>
                            <p class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">
                                A regra mais eficaz, incentiva o retorno dos clientes ao oferecer saldo em conta para utilizar numa próxima visita
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="content-fidelization-itens-cards-item">
                        <div class="content-fidelization-itens-cards-item-img">
                            <img src="@/assets/img/merchant/rule4.png" alt="">
                        </div>
                        <div class="content-fidelization-itens-cards-item-text">
                            <h2 class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">Oferta com valor mínimo de compra</h2>
                            <p class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">
                                Regra com o objetivo de potenciar o aumento do ticket médio
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="content-fidelization-itens-cards-item">
                        <div class="content-fidelization-itens-cards-item-img">
                            <img src="@/assets/img/merchant/rule4.png" alt="">
                        </div>
                        <div class="content-fidelization-itens-cards-item-text">
                            <h2 class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">Desconto por Objetivos</h2>
                            <p class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">
                                Na compra de X produtos ou a cada Y€ o cliente tem a oferta de menu/saldo em conta
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="content-fidelization-itens-cards-item">
                        <div class="content-fidelization-itens-cards-item-img">
                            <img src="@/assets/img/merchant/rule5.png" alt="">
                        </div>
                        <div class="content-fidelization-itens-cards-item-text">
                            <h2 class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">Hot Deal</h2>
                            <p class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">
                                Campanhas pontuais para atrair os clientes ao seu ponto de venda
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="content-fidelization-itens-cards-item">
                        <div class="content-fidelization-itens-cards-item-img">
                            <img src="@/assets/img/merchant/rule6.png" alt="">
                        </div>
                        <div class="content-fidelization-itens-cards-item-text">
                            <h2 class="v-content-merchant-fidelization" v-contentMerchantFidelization="{ section: 'Fidelização', removeHtml: true }">e muito mais...</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import store from "@/store";

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
  name: "Banner",
  data() {
    return {};
  },
  methods: {
    updateDirectives() {
        const allElements = document.querySelectorAll('.v-content-merchant-fidelization');
        allContents.splice(0, allContents.length); // clear the contents array
        allElements.forEach((el) => {
            const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
            params.content = el.innerHTML.trim();
            (!('type' in params) ? params.type = 'text' : null);
            params.theme = process.env.VUE_APP_THEME;
            params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
            allContents.push(params);
        });
    },
  },
  created() {
    this.updateDirectives();
  },
  mounted() {},
  directives: {
      contentMerchantFidelization: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-merchant-fidelization');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
  
                const allElements = document.querySelectorAll('.v-content-merchant-fidelization');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
};
</script>
<style lang="scss">
.content-fidelization{
    margin: 50px 0 100px 0;
    &-itens{
        &-title{
            width: 100%;
            height: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            h1{
                font-family: 'Font Bold';
                font-size: 45px;
                line-height: 60px;
                text-align: center;
                color: var(--main-color);
                margin-bottom: 100px;
                @media screen and (max-width: 991px) {
                    font-size: 26px;
                    line-height: 36px;
                    margin-bottom: 50px;
                }
            }
        }
        &-cards{
            display: flex;
            justify-content: center;
            align-items: center;
            &-item{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;
                gap: 30px;
                margin-bottom: 55px;
                &-img{
                    width: 100%;
                    height: auto;
                    max-width: 240px;
                    img{
                        width: 230px;
                        height: auto;
                    }
                    @media screen and (max-width: 1500px) {
                        img{
                            width: 200px;
                            height: auto;
                        }
                    }
                    @media screen and (max-width: 1300px) {
                        img{
                            width: 180px;
                            height: auto;
                        }
                    }
                    @media screen and (max-width: 991px) {
                        width: auto;
                        img{
                            width: 120px;
                            height: auto;
                        }
                    }
                    @media screen and (max-width: 556px) {
                        img{
                            width: 120px;
                            height: auto;
                        }
                    }
                }
                &-text{
                    text-align: left;
                    h2{
                        font-family: 'Font Bold';
                        font-size: 35px;
                        line-height: 45px;
                        color: var(--main-color);
                        margin-bottom: 20px;
                        @media screen and (max-width: 1500px) {
                            font-size: 30px;
                            line-height: 40px;
                        }
                        @media screen and (max-width: 1300px) {
                            font-size: 25px;
                            line-height: 30px;
                            margin-bottom: 10px;
                        }
                        @media screen and (max-width: 991px) {
                            font-size: 16px;
                            line-height: 26px;
                        }
                    }
                    p{
                        font-family: 'Font Regular';
                        font-size: 24px;
                        line-height: 40px;
                        color: var(--gray);
                        @media screen and (max-width: 1500px) {
                            line-height: 30px;
                        }
                        @media screen and (max-width: 1300px) {
                            font-size: 20px;
                            line-height: 26px;
                        }
                        @media screen and (max-width: 991px) {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}

.col-md-6{
    @media screen and (max-width: 556px) {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
</style>
